import { rootPaths } from "./routesPaths";

const routes = [
    {
        path: rootPaths.LOGIN,
        exact: true,
        name: "login-page",
        type: "public",
        loader: () => import("../Login"),
    },
    {
        path: rootPaths.HOME,
        exact: true,
        name: "homepage",
        type: "authed",
        loader: () => import("../Home"),
    },
    {
        path: rootPaths.PAYMENT_REDIRECT,
        exact: true,
        name: "payment-redirect",
        type: "authed",
        loader: () => import("../Home"),
    },
    {
        path: rootPaths.LOGOUT,
        exact: true,
        type: "authed",
        loader: () => import("../Logout"),
    },
];

export default routes;
